@reference "../../../theme.css";

@layer atoms.label.base {
	.label {
		@apply block uppercase tracking-wider text-ink-2;
	}

	.label--sm {
		@apply text-[10px];
	}

	.label--md {
		@apply text-xs;
	}
} /* end @layer atoms.label.base */
